// This file is auto-generated by scripts/generate-icons-package.ts

// Do not edit this file manually

import Icon_3dBackgroundAdd from "./generated-icons/3d-background-add.svg?react";
import Icon_3dBackground from "./generated-icons/3d-background.svg?react";
import Icon_Above from "./generated-icons/above.svg?react";
import Icon_AddCaptions from "./generated-icons/add-captions.svg?react";
import Icon_AddSmall from "./generated-icons/add-small.svg?react";
import Icon_AddText from "./generated-icons/add-text.svg?react";
import Icon_AddWord from "./generated-icons/add-word.svg?react";
import Icon_Add from "./generated-icons/add.svg?react";
import Icon_Adjust from "./generated-icons/adjust.svg?react";
import Icon_AiAds from "./generated-icons/ai-ads.svg?react";
import Icon_AiColor from "./generated-icons/ai-color.svg?react";
import Icon_AiEdit from "./generated-icons/ai-edit.svg?react";
import Icon_AiTwin from "./generated-icons/ai-twin.svg?react";
import Icon_AnimateVideo from "./generated-icons/animate-video.svg?react";
import Icon_AnimationCurve from "./generated-icons/animation-curve.svg?react";
import Icon_Animation from "./generated-icons/animation.svg?react";
import Icon_Api from "./generated-icons/api.svg?react";
import Icon_Apple from "./generated-icons/apple.svg?react";
import Icon_AspectRatio1x1 from "./generated-icons/aspect-ratio-1x1.svg?react";
import Icon_AspectRatio2 from "./generated-icons/aspect-ratio-2.svg?react";
import Icon_AspectRatio4x5 from "./generated-icons/aspect-ratio-4x5.svg?react";
import Icon_AspectRatio9x16 from "./generated-icons/aspect-ratio-9x16.svg?react";
import Icon_AspectRatio16x9 from "./generated-icons/aspect-ratio-16x9.svg?react";
import Icon_AspectRatio from "./generated-icons/aspect-ratio.svg?react";
import Icon_Attachment from "./generated-icons/attachment.svg?react";
import Icon_AudioDucking from "./generated-icons/audio-ducking.svg?react";
import Icon_AudioTranslated from "./generated-icons/audio-translated.svg?react";
import Icon_AutoFit from "./generated-icons/auto-fit.svg?react";
import Icon_Auto from "./generated-icons/auto.svg?react";
import Icon_Baby from "./generated-icons/baby.svg?react";
import Icon_BackgroundShine from "./generated-icons/background-shine.svg?react";
import Icon_Background from "./generated-icons/background.svg?react";
import Icon_Backward10s from "./generated-icons/backward-10s.svg?react";
import Icon_Bar from "./generated-icons/bar.svg?react";
import Icon_Bell from "./generated-icons/bell.svg?react";
import Icon_Below from "./generated-icons/below.svg?react";
import Icon_Blend from "./generated-icons/blend.svg?react";
import Icon_Block from "./generated-icons/block.svg?react";
import Icon_Blur from "./generated-icons/blur.svg?react";
import Icon_Bokeh from "./generated-icons/bokeh.svg?react";
import Icon_BookShine from "./generated-icons/book-shine.svg?react";
import Icon_Book from "./generated-icons/book.svg?react";
import Icon_Brain from "./generated-icons/brain.svg?react";
import Icon_BreakDesktop from "./generated-icons/break-desktop.svg?react";
import Icon_BreakPage from "./generated-icons/break-page.svg?react";
import Icon_Briefcase from "./generated-icons/briefcase.svg?react";
import Icon_BulletList from "./generated-icons/bullet-list.svg?react";
import Icon_Calendar from "./generated-icons/calendar.svg?react";
import Icon_Cap from "./generated-icons/cap.svg?react";
import Icon_CaptionCoin from "./generated-icons/caption-coin.svg?react";
import Icon_CaptionsAdd from "./generated-icons/captions-add.svg?react";
import Icon_CaptionsAi from "./generated-icons/captions-ai.svg?react";
import Icon_CaptionsBare from "./generated-icons/captions-bare.svg?react";
import Icon_CaptionsBottom from "./generated-icons/captions-bottom.svg?react";
import Icon_CaptionsEdit from "./generated-icons/captions-edit.svg?react";
import Icon_CaptionsEmphasis from "./generated-icons/captions-emphasis.svg?react";
import Icon_CaptionsFlowerClover from "./generated-icons/captions-flower-clover.svg?react";
import Icon_CaptionsFlowerPedal from "./generated-icons/captions-flower-pedal.svg?react";
import Icon_CaptionsFlower from "./generated-icons/captions-flower.svg?react";
import Icon_CaptionsMiddle from "./generated-icons/captions-middle.svg?react";
import Icon_CaptionsPerson from "./generated-icons/captions-person.svg?react";
import Icon_CaptionsTiming from "./generated-icons/captions-timing.svg?react";
import Icon_CaptionsTop from "./generated-icons/captions-top.svg?react";
import Icon_CaptionsTranslated from "./generated-icons/captions-translated.svg?react";
import Icon_Caution from "./generated-icons/caution.svg?react";
import Icon_Censor from "./generated-icons/censor.svg?react";
import Icon_ChainBroken from "./generated-icons/chain-broken.svg?react";
import Icon_Chain from "./generated-icons/chain.svg?react";
import Icon_CharacterAdd from "./generated-icons/character-add.svg?react";
import Icon_ChatShine from "./generated-icons/chat-shine.svg?react";
import Icon_Chat from "./generated-icons/chat.svg?react";
import Icon_Check from "./generated-icons/check.svg?react";
import Icon_CheckmarkEmpty from "./generated-icons/checkmark-empty.svg?react";
import Icon_CheckmarkFill from "./generated-icons/checkmark-fill.svg?react";
import Icon_CheckmarkNumber from "./generated-icons/checkmark-number.svg?react";
import Icon_ChevronDown from "./generated-icons/chevron-down.svg?react";
import Icon_ChevronLeft from "./generated-icons/chevron-left.svg?react";
import Icon_ChevronRight from "./generated-icons/chevron-right.svg?react";
import Icon_ChevronUp from "./generated-icons/chevron-up.svg?react";
import Icon_Circle2 from "./generated-icons/circle-2.svg?react";
import Icon_Circle from "./generated-icons/circle.svg?react";
import Icon_ClapBoard from "./generated-icons/clap-board.svg?react";
import Icon_ClipAdd from "./generated-icons/clip-add.svg?react";
import Icon_CloseBubble from "./generated-icons/close-bubble.svg?react";
import Icon_CloseFilled from "./generated-icons/close-filled.svg?react";
import Icon_Clothes from "./generated-icons/clothes.svg?react";
import Icon_CloudDownload from "./generated-icons/cloud-download.svg?react";
import Icon_Color2 from "./generated-icons/color-2.svg?react";
import Icon_ColorHalfFilled from "./generated-icons/color-half-filled.svg?react";
import Icon_Color from "./generated-icons/color.svg?react";
import Icon_Comments from "./generated-icons/comments.svg?react";
import Icon_ContentAuto from "./generated-icons/content-auto.svg?react";
import Icon_ContentFit from "./generated-icons/content-fit.svg?react";
import Icon_Conversation from "./generated-icons/conversation.svg?react";
import Icon_CopyAi from "./generated-icons/copy-ai.svg?react";
import Icon_CopyBare from "./generated-icons/copy-bare.svg?react";
import Icon_Copy from "./generated-icons/copy.svg?react";
import Icon_CornerRadius from "./generated-icons/corner-radius.svg?react";
import Icon_Create2 from "./generated-icons/create-2.svg?react";
import Icon_CreateTemplate from "./generated-icons/create-template.svg?react";
import Icon_Create from "./generated-icons/create.svg?react";
import Icon_CreditCard from "./generated-icons/credit-card.svg?react";
import Icon_CreditsShine from "./generated-icons/credits-shine.svg?react";
import Icon_Credits from "./generated-icons/credits.svg?react";
import Icon_Crop from "./generated-icons/crop.svg?react";
import Icon_CrossSmall from "./generated-icons/cross-small.svg?react";
import Icon_Cross from "./generated-icons/cross.svg?react";
import Icon_CrumpledPaper from "./generated-icons/crumpled-paper.svg?react";
import Icon_Cube from "./generated-icons/cube.svg?react";
import Icon_CutoutBgRemoval from "./generated-icons/cutout-bg-removal.svg?react";
import Icon_CutoutBgV2 from "./generated-icons/cutout-bg-v2.svg?react";
import Icon_Dark from "./generated-icons/dark.svg?react";
import Icon_Default from "./generated-icons/default.svg?react";
import Icon_DeleteAll from "./generated-icons/delete-all.svg?react";
import Icon_DeleteBare from "./generated-icons/delete-bare.svg?react";
import Icon_Delete from "./generated-icons/delete.svg?react";
import Icon_DenoiseBox from "./generated-icons/denoise-box.svg?react";
import Icon_Denoise from "./generated-icons/denoise.svg?react";
import Icon_Diamond from "./generated-icons/diamond.svg?react";
import Icon_DottedLineShine from "./generated-icons/dotted-line-shine.svg?react";
import Icon_DownArrowSmall from "./generated-icons/down-arrow-small.svg?react";
import Icon_Down from "./generated-icons/down.svg?react";
import Icon_Download from "./generated-icons/download.svg?react";
import Icon_Duplicate from "./generated-icons/duplicate.svg?react";
import Icon_Duration2 from "./generated-icons/duration-2.svg?react";
import Icon_Duration15 from "./generated-icons/duration-15.svg?react";
import Icon_Duration30 from "./generated-icons/duration-30.svg?react";
import Icon_Duration45 from "./generated-icons/duration-45.svg?react";
import Icon_Duration60 from "./generated-icons/duration-60.svg?react";
import Icon_Duration90 from "./generated-icons/duration-90.svg?react";
import Icon_Duration from "./generated-icons/duration.svg?react";
import Icon_Ease from "./generated-icons/ease.svg?react";
import Icon_Echo from "./generated-icons/echo.svg?react";
import Icon_EditBare from "./generated-icons/edit-bare.svg?react";
import Icon_EditFilled from "./generated-icons/edit-filled.svg?react";
import Icon_EditShot from "./generated-icons/edit-shot.svg?react";
import Icon_EditWord from "./generated-icons/edit-word.svg?react";
import Icon_Edit from "./generated-icons/edit.svg?react";
import Icon_Effects from "./generated-icons/effects.svg?react";
import Icon_Email from "./generated-icons/email.svg?react";
import Icon_EmojiShine from "./generated-icons/emoji-shine.svg?react";
import Icon_Emoji from "./generated-icons/emoji.svg?react";
import Icon_Emphasize from "./generated-icons/emphasize.svg?react";
import Icon_EnlargeFlipped from "./generated-icons/enlarge-flipped.svg?react";
import Icon_Enlarge from "./generated-icons/enlarge.svg?react";
import Icon_Error2 from "./generated-icons/error-2.svg?react";
import Icon_Error from "./generated-icons/error.svg?react";
import Icon_Exclude from "./generated-icons/exclude.svg?react";
import Icon_ExpandFlipped from "./generated-icons/expand-flipped.svg?react";
import Icon_Expand from "./generated-icons/expand.svg?react";
import Icon_Export from "./generated-icons/export.svg?react";
import Icon_ExtractAudio from "./generated-icons/extract-audio.svg?react";
import Icon_EyeContact from "./generated-icons/eye-contact.svg?react";
import Icon_EyeOff from "./generated-icons/eye-off.svg?react";
import Icon_Eye from "./generated-icons/eye.svg?react";
import Icon_FaceTracking from "./generated-icons/face-tracking.svg?react";
import Icon_Fade from "./generated-icons/fade.svg?react";
import Icon_Fan from "./generated-icons/fan.svg?react";
import Icon_FastBackward from "./generated-icons/fast-backward.svg?react";
import Icon_FastForward from "./generated-icons/fast-forward.svg?react";
import Icon_Fill from "./generated-icons/fill.svg?react";
import Icon_FilmStripAdd from "./generated-icons/film-strip-add.svg?react";
import Icon_FilmStripCheck from "./generated-icons/film-strip-check.svg?react";
import Icon_FilmStripCut from "./generated-icons/film-strip-cut.svg?react";
import Icon_FilmStripDownload from "./generated-icons/film-strip-download.svg?react";
import Icon_FilmStripExtend from "./generated-icons/film-strip-extend.svg?react";
import Icon_FilmStripMultiple from "./generated-icons/film-strip-multiple.svg?react";
import Icon_FilmStripReplace from "./generated-icons/film-strip-replace.svg?react";
import Icon_FilmStripShine from "./generated-icons/film-strip-shine.svg?react";
import Icon_FilmStrip from "./generated-icons/film-strip.svg?react";
import Icon_FilmStripeCut from "./generated-icons/film-stripe-cut.svg?react";
import Icon_FilmStripeExtend from "./generated-icons/film-stripe-extend.svg?react";
import Icon_FilmStripeScene from "./generated-icons/film-stripe-scene.svg?react";
import Icon_FilmStripeSwatch from "./generated-icons/film-stripe-swatch.svg?react";
import Icon_Film from "./generated-icons/film.svg?react";
import Icon_Filter from "./generated-icons/filter.svg?react";
import Icon_Filtering from "./generated-icons/filtering.svg?react";
import Icon_Fire2 from "./generated-icons/fire-2.svg?react";
import Icon_Fire from "./generated-icons/fire.svg?react";
import Icon_Fit from "./generated-icons/fit.svg?react";
import Icon_Flare from "./generated-icons/flare.svg?react";
import Icon_Flash2 from "./generated-icons/flash-2.svg?react";
import Icon_FlashCamera from "./generated-icons/flash-camera.svg?react";
import Icon_Flash from "./generated-icons/flash.svg?react";
import Icon_Flick from "./generated-icons/flick.svg?react";
import Icon_Flip2 from "./generated-icons/flip-2.svg?react";
import Icon_FlipHorizontally from "./generated-icons/flip-horizontally.svg?react";
import Icon_FlipVertically from "./generated-icons/flip-vertically.svg?react";
import Icon_Flip from "./generated-icons/flip.svg?react";
import Icon_Fold from "./generated-icons/fold.svg?react";
import Icon_FolderAdd from "./generated-icons/folder-add.svg?react";
import Icon_FolderDownload from "./generated-icons/folder-download.svg?react";
import Icon_FolderOpen from "./generated-icons/folder-open.svg?react";
import Icon_Folder from "./generated-icons/folder.svg?react";
import Icon_Font from "./generated-icons/font.svg?react";
import Icon_Forward10s from "./generated-icons/forward-10s.svg?react";
import Icon_FreeForm from "./generated-icons/free-form.svg?react";
import Icon_GenZ from "./generated-icons/gen-z.svg?react";
import Icon_Gif from "./generated-icons/gif.svg?react";
import Icon_Glasses from "./generated-icons/glasses.svg?react";
import Icon_Glitch from "./generated-icons/glitch.svg?react";
import Icon_Glow from "./generated-icons/glow.svg?react";
import Icon_Google from "./generated-icons/google.svg?react";
import Icon_Grab from "./generated-icons/grab.svg?react";
import Icon_GradientLoadingNumber from "./generated-icons/gradient-loading-number.svg?react";
import Icon_GradientLoading from "./generated-icons/gradient-loading.svg?react";
import Icon_Group from "./generated-icons/group.svg?react";
import Icon_HamburgerMenu from "./generated-icons/hamburger-menu.svg?react";
import Icon_HandleAsym from "./generated-icons/handle-asym.svg?react";
import Icon_HandleNone from "./generated-icons/handle-none.svg?react";
import Icon_HandleSym from "./generated-icons/handle-sym.svg?react";
import Icon_Hd from "./generated-icons/hd.svg?react";
import Icon_HelpFilled from "./generated-icons/help-filled.svg?react";
import Icon_Help from "./generated-icons/help.svg?react";
import Icon_HidePunctuation from "./generated-icons/hide-punctuation.svg?react";
import Icon_Hide from "./generated-icons/hide.svg?react";
import Icon_Home from "./generated-icons/home.svg?react";
import Icon_ImageAdd from "./generated-icons/image-add.svg?react";
import Icon_ImageMultiple from "./generated-icons/image-multiple.svg?react";
import Icon_ImageReplace from "./generated-icons/image-replace.svg?react";
import Icon_ImageShine from "./generated-icons/image-shine.svg?react";
import Icon_Image from "./generated-icons/image.svg?react";
import Icon_Import from "./generated-icons/import.svg?react";
import Icon_Info from "./generated-icons/info.svg?react";
import Icon_InstagramStory from "./generated-icons/instagram-story.svg?react";
import Icon_Instagram from "./generated-icons/instagram.svg?react";
import Icon_Instant from "./generated-icons/instant.svg?react";
import Icon_IntensityHighFilled from "./generated-icons/intensity-high-filled.svg?react";
import Icon_IntensityLowFilled from "./generated-icons/intensity-low-filled.svg?react";
import Icon_IntensityMediumFilled from "./generated-icons/intensity-medium-filled.svg?react";
import Icon_IntensitySelectHigh from "./generated-icons/intensity-select-high.svg?react";
import Icon_IntensitySelectedLow from "./generated-icons/intensity-selected-low.svg?react";
import Icon_IntensitySelectedMedium from "./generated-icons/intensity-selected-medium.svg?react";
import Icon_Intensity from "./generated-icons/intensity.svg?react";
import Icon_Intersect from "./generated-icons/intersect.svg?react";
import Icon_Intro from "./generated-icons/intro.svg?react";
import Icon_JustifiedAlign from "./generated-icons/justified-align.svg?react";
import Icon_KeyframeAdd from "./generated-icons/keyframe-add.svg?react";
import Icon_KeyframeConvert from "./generated-icons/keyframe-convert.svg?react";
import Icon_KeyframeDelete from "./generated-icons/keyframe-delete.svg?react";
import Icon_KeyframesStack from "./generated-icons/keyframes-stack.svg?react";
import Icon_Keyframes from "./generated-icons/keyframes.svg?react";
import Icon_Language from "./generated-icons/language.svg?react";
import Icon_Laptop from "./generated-icons/laptop.svg?react";
import Icon_Leak from "./generated-icons/leak.svg?react";
import Icon_LeftAlign2 from "./generated-icons/left-align-2.svg?react";
import Icon_LeftAlign from "./generated-icons/left-align.svg?react";
import Icon_LeftArrowSmall from "./generated-icons/left-arrow-small.svg?react";
import Icon_LeftDown from "./generated-icons/left-down.svg?react";
import Icon_LeftUp from "./generated-icons/left-up.svg?react";
import Icon_Left from "./generated-icons/left.svg?react";
import Icon_Lengthen from "./generated-icons/lengthen.svg?react";
import Icon_Light from "./generated-icons/light.svg?react";
import Icon_Like from "./generated-icons/like.svg?react";
import Icon_Line2 from "./generated-icons/line-2.svg?react";
import Icon_LineHeight from "./generated-icons/line-height.svg?react";
import Icon_Line from "./generated-icons/line.svg?react";
import Icon_Linear from "./generated-icons/linear.svg?react";
import Icon_LinkOut from "./generated-icons/link-out.svg?react";
import Icon_Linkedin from "./generated-icons/linkedin.svg?react";
import Icon_LipAuto from "./generated-icons/lip-auto.svg?react";
import Icon_LoadingSpinner from "./generated-icons/loading-spinner.svg?react";
import Icon_Lock from "./generated-icons/lock.svg?react";
import Icon_Magnifying from "./generated-icons/magnifying.svg?react";
import Icon_Mask from "./generated-icons/mask.svg?react";
import Icon_Merge from "./generated-icons/merge.svg?react";
import Icon_Metadata from "./generated-icons/metadata.svg?react";
import Icon_MicAdd from "./generated-icons/mic-add.svg?react";
import Icon_MicCheck from "./generated-icons/mic-check.svg?react";
import Icon_MicDouble from "./generated-icons/mic-double.svg?react";
import Icon_MicEdit from "./generated-icons/mic-edit.svg?react";
import Icon_MicShine from "./generated-icons/mic-shine.svg?react";
import Icon_Mic from "./generated-icons/mic.svg?react";
import Icon_Microsoft from "./generated-icons/microsoft.svg?react";
import Icon_MiddleAlign2 from "./generated-icons/middle-align-2.svg?react";
import Icon_MiddleAlign from "./generated-icons/middle-align.svg?react";
import Icon_MilkBottle from "./generated-icons/milk-bottle.svg?react";
import Icon_Minimize2 from "./generated-icons/minimize-2.svg?react";
import Icon_Minimize3 from "./generated-icons/minimize-3.svg?react";
import Icon_MinimizeFlipped2 from "./generated-icons/minimize-flipped-2.svg?react";
import Icon_MinimizeFlipped from "./generated-icons/minimize-flipped.svg?react";
import Icon_Minimize from "./generated-icons/minimize.svg?react";
import Icon_MirageCoin from "./generated-icons/mirage-coin.svg?react";
import Icon_MirageIcon from "./generated-icons/mirage-icon.svg?react";
import Icon_Mirage from "./generated-icons/mirage.svg?react";
import Icon_Mirror from "./generated-icons/mirror.svg?react";
import Icon_Money from "./generated-icons/money.svg?react";
import Icon_Multidub from "./generated-icons/multidub.svg?react";
import Icon_Multimedia from "./generated-icons/multimedia.svg?react";
import Icon_MusicShine from "./generated-icons/music-shine.svg?react";
import Icon_Music from "./generated-icons/music.svg?react";
import Icon_Negative from "./generated-icons/negative.svg?react";
import Icon_NewChat from "./generated-icons/new-chat.svg?react";
import Icon_None from "./generated-icons/none.svg?react";
import Icon_Offline from "./generated-icons/offline.svg?react";
import Icon_Online from "./generated-icons/online.svg?react";
import Icon_Options from "./generated-icons/options.svg?react";
import Icon_OutlineCheckmark from "./generated-icons/outline-checkmark.svg?react";
import Icon_Outro from "./generated-icons/outro.svg?react";
import Icon_Overlay from "./generated-icons/overlay.svg?react";
import Icon_Pag from "./generated-icons/pag.svg?react";
import Icon_Page2 from "./generated-icons/page-2.svg?react";
import Icon_Page from "./generated-icons/page.svg?react";
import Icon_Paint from "./generated-icons/paint.svg?react";
import Icon_PauseButton from "./generated-icons/pause-button.svg?react";
import Icon_PersonAdd from "./generated-icons/person-add.svg?react";
import Icon_PersonAiMirage from "./generated-icons/person-ai-mirage.svg?react";
import Icon_PersonAi from "./generated-icons/person-ai.svg?react";
import Icon_Person from "./generated-icons/person.svg?react";
import Icon_PhoneNumber from "./generated-icons/phone-number.svg?react";
import Icon_Phone from "./generated-icons/phone.svg?react";
import Icon_Pirate from "./generated-icons/pirate.svg?react";
import Icon_Pixel from "./generated-icons/pixel.svg?react";
import Icon_Planner from "./generated-icons/planner.svg?react";
import Icon_PlayButton from "./generated-icons/play-button.svg?react";
import Icon_Pop from "./generated-icons/pop.svg?react";
import Icon_Position2 from "./generated-icons/position-2.svg?react";
import Icon_PositionBottom from "./generated-icons/position-bottom.svg?react";
import Icon_PositionCaptions from "./generated-icons/position-captions.svg?react";
import Icon_PositionFreeform from "./generated-icons/position-freeform.svg?react";
import Icon_PositionFull from "./generated-icons/position-full.svg?react";
import Icon_PositionLeft from "./generated-icons/position-left.svg?react";
import Icon_PositionRight from "./generated-icons/position-right.svg?react";
import Icon_PositionTop from "./generated-icons/position-top.svg?react";
import Icon_Position from "./generated-icons/position.svg?react";
import Icon_Profile from "./generated-icons/profile.svg?react";
import Icon_ProgressLoadingNum from "./generated-icons/progress-loading-num.svg?react";
import Icon_ProgressLoading from "./generated-icons/progress-loading.svg?react";
import Icon_ProjectList from "./generated-icons/project-list.svg?react";
import Icon_PurpleGradientLoading from "./generated-icons/purple-gradient-loading.svg?react";
import Icon_RandomDice from "./generated-icons/random-dice.svg?react";
import Icon_Random from "./generated-icons/random.svg?react";
import Icon_RedditToVideo from "./generated-icons/reddit-to-video.svg?react";
import Icon_Reddit from "./generated-icons/reddit.svg?react";
import Icon_Redo from "./generated-icons/redo.svg?react";
import Icon_Reel from "./generated-icons/reel.svg?react";
import Icon_Reorder from "./generated-icons/reorder.svg?react";
import Icon_Rephrase2 from "./generated-icons/rephrase-2.svg?react";
import Icon_Rephrase from "./generated-icons/rephrase.svg?react";
import Icon_ReplaceBareFlip from "./generated-icons/replace-bare-flip.svg?react";
import Icon_ReplaceBare from "./generated-icons/replace-bare.svg?react";
import Icon_ReplaceSound2 from "./generated-icons/replace-sound-2.svg?react";
import Icon_ReplaceSound from "./generated-icons/replace-sound.svg?react";
import Icon_Replace from "./generated-icons/replace.svg?react";
import Icon_RetroPaper from "./generated-icons/retro-paper.svg?react";
import Icon_Return from "./generated-icons/return.svg?react";
import Icon_Revoice2 from "./generated-icons/revoice-2.svg?react";
import Icon_RevoiceBox from "./generated-icons/revoice-box.svg?react";
import Icon_Revoice from "./generated-icons/revoice.svg?react";
import Icon_RightAlign2 from "./generated-icons/right-align-2.svg?react";
import Icon_RightAlign from "./generated-icons/right-align.svg?react";
import Icon_RightArrowSmall from "./generated-icons/right-arrow-small.svg?react";
import Icon_RightDown from "./generated-icons/right-down.svg?react";
import Icon_RightUp from "./generated-icons/right-up.svg?react";
import Icon_Right from "./generated-icons/right.svg?react";
import Icon_Rotate90Degrees from "./generated-icons/rotate-90-degrees.svg?react";
import Icon_Rotate from "./generated-icons/rotate.svg?react";
import Icon_Rotation from "./generated-icons/rotation.svg?react";
import Icon_Ruler from "./generated-icons/ruler.svg?react";
import Icon_Save from "./generated-icons/save.svg?react";
import Icon_Saved from "./generated-icons/saved.svg?react";
import Icon_Scale1x1 from "./generated-icons/scale-1x1.svg?react";
import Icon_Scale4x5 from "./generated-icons/scale-4x5.svg?react";
import Icon_Scale9x16 from "./generated-icons/scale-9x16.svg?react";
import Icon_Scale16x9 from "./generated-icons/scale-16x9.svg?react";
import Icon_Scale from "./generated-icons/scale.svg?react";
import Icon_Scatter from "./generated-icons/scatter.svg?react";
import Icon_Scenes from "./generated-icons/scenes.svg?react";
import Icon_Script2 from "./generated-icons/script-2.svg?react";
import Icon_Script from "./generated-icons/script.svg?react";
import Icon_Scrolling from "./generated-icons/scrolling.svg?react";
import Icon_SearchCaptions from "./generated-icons/search-captions.svg?react";
import Icon_SelectAll from "./generated-icons/select-all.svg?react";
import Icon_Setting from "./generated-icons/setting.svg?react";
import Icon_Shadow from "./generated-icons/shadow.svg?react";
import Icon_Shake from "./generated-icons/shake.svg?react";
import Icon_ShapeBottomAlign from "./generated-icons/shape-bottom-align.svg?react";
import Icon_ShapeHCenterAlign from "./generated-icons/shape-h-center-align.svg?react";
import Icon_ShapeLeftAlign from "./generated-icons/shape-left-align.svg?react";
import Icon_ShapeRightAlign from "./generated-icons/shape-right-align.svg?react";
import Icon_ShapeTopAlign from "./generated-icons/shape-top-align.svg?react";
import Icon_ShapeVCenterAlign from "./generated-icons/shape-v-center-align.svg?react";
import Icon_Shield from "./generated-icons/shield.svg?react";
import Icon_Shopify from "./generated-icons/shopify.svg?react";
import Icon_ShortcutDisplay from "./generated-icons/shortcut-display.svg?react";
import Icon_Shorten from "./generated-icons/shorten.svg?react";
import Icon_Shorts from "./generated-icons/shorts.svg?react";
import Icon_Show from "./generated-icons/show.svg?react";
import Icon_Shuffle from "./generated-icons/shuffle.svg?react";
import Icon_Shutter from "./generated-icons/shutter.svg?react";
import Icon_SizeLg from "./generated-icons/size-lg.svg?react";
import Icon_SizeMe from "./generated-icons/size-me.svg?react";
import Icon_SizeSm from "./generated-icons/size-sm.svg?react";
import Icon_Slow from "./generated-icons/slow.svg?react";
import Icon_Snapchat from "./generated-icons/snapchat.svg?react";
import Icon_Sound2 from "./generated-icons/sound-2.svg?react";
import Icon_SoundAdd from "./generated-icons/sound-add.svg?react";
import Icon_SoundOff2 from "./generated-icons/sound-off-2.svg?react";
import Icon_SoundOff3 from "./generated-icons/sound-off-3.svg?react";
import Icon_SoundOff from "./generated-icons/sound-off.svg?react";
import Icon_SoundShine from "./generated-icons/sound-shine.svg?react";
import Icon_SoundWaves from "./generated-icons/sound-waves.svg?react";
import Icon_Sound from "./generated-icons/sound.svg?react";
import Icon_Space from "./generated-icons/space.svg?react";
import Icon_Spacing from "./generated-icons/spacing.svg?react";
import Icon_Sparkles from "./generated-icons/sparkles.svg?react";
import Icon_Speaker2 from "./generated-icons/speaker-2.svg?react";
import Icon_Speaker from "./generated-icons/speaker.svg?react";
import Icon_Speed from "./generated-icons/speed.svg?react";
import Icon_Split2 from "./generated-icons/split-2.svg?react";
import Icon_SplitScreenHorizontal from "./generated-icons/split-screen-horizontal.svg?react";
import Icon_SplitScreenVertical from "./generated-icons/split-screen-vertical.svg?react";
import Icon_Split from "./generated-icons/split.svg?react";
import Icon_Square from "./generated-icons/square.svg?react";
import Icon_Srt from "./generated-icons/srt.svg?react";
import Icon_Stack from "./generated-icons/stack.svg?react";
import Icon_StopButton from "./generated-icons/stop-button.svg?react";
import Icon_Storage from "./generated-icons/storage.svg?react";
import Icon_Stretch2 from "./generated-icons/stretch-2.svg?react";
import Icon_StretchRound from "./generated-icons/stretch-round.svg?react";
import Icon_Stretch from "./generated-icons/stretch.svg?react";
import Icon_StrokeAll from "./generated-icons/stroke-all.svg?react";
import Icon_StrokeBottom from "./generated-icons/stroke-bottom.svg?react";
import Icon_StrokeLeft from "./generated-icons/stroke-left.svg?react";
import Icon_StrokeRight from "./generated-icons/stroke-right.svg?react";
import Icon_StrokeTop from "./generated-icons/stroke-top.svg?react";
import Icon_Stroke from "./generated-icons/stroke.svg?react";
import Icon_Style from "./generated-icons/style.svg?react";
import Icon_Subtract2 from "./generated-icons/subtract-2.svg?react";
import Icon_SubtractSmall from "./generated-icons/subtract-small.svg?react";
import Icon_Subtract from "./generated-icons/subtract.svg?react";
import Icon_Success2 from "./generated-icons/success-2.svg?react";
import Icon_Success from "./generated-icons/success.svg?react";
import Icon_SuperFast from "./generated-icons/super-fast.svg?react";
import Icon_Surprise from "./generated-icons/surprise.svg?react";
import Icon_SwipeDownRound from "./generated-icons/swipe-down-round.svg?react";
import Icon_SwipeLeftRound from "./generated-icons/swipe-left-round.svg?react";
import Icon_SwipeLeft from "./generated-icons/swipe-left.svg?react";
import Icon_SwipeRightRound from "./generated-icons/swipe-right-round.svg?react";
import Icon_SwipeUpRound from "./generated-icons/swipe-up-round.svg?react";
import Icon_SwipeUp from "./generated-icons/swipe-up.svg?react";
import Icon_Switch from "./generated-icons/switch.svg?react";
import Icon_Switcher from "./generated-icons/switcher.svg?react";
import Icon_Tag from "./generated-icons/tag.svg?react";
import Icon_TeamsBox from "./generated-icons/teams-box.svg?react";
import Icon_Teams from "./generated-icons/teams.svg?react";
import Icon_Teleprompter from "./generated-icons/teleprompter.svg?react";
import Icon_Texas from "./generated-icons/texas.svg?react";
import Icon_TextShine from "./generated-icons/text-shine.svg?react";
import Icon_TextStyle from "./generated-icons/text-style.svg?react";
import Icon_Text from "./generated-icons/text.svg?react";
import Icon_ThumbDownFilled from "./generated-icons/thumb-down-filled.svg?react";
import Icon_ThumbDown from "./generated-icons/thumb-down.svg?react";
import Icon_ThumbUpFilled from "./generated-icons/thumb-up-filled.svg?react";
import Icon_ThumbUp from "./generated-icons/thumb-up.svg?react";
import Icon_Tiktok from "./generated-icons/tiktok.svg?react";
import Icon_Timelines from "./generated-icons/timelines.svg?react";
import Icon_Timing2 from "./generated-icons/timing-2.svg?react";
import Icon_TimingFilled from "./generated-icons/timing-filled.svg?react";
import Icon_Timing from "./generated-icons/timing.svg?react";
import Icon_Tip from "./generated-icons/tip.svg?react";
import Icon_Title2 from "./generated-icons/title-2.svg?react";
import Icon_Title from "./generated-icons/title.svg?react";
import Icon_ToClip from "./generated-icons/to-clip.svg?react";
import Icon_ToOverlay from "./generated-icons/to-overlay.svg?react";
import Icon_Tone from "./generated-icons/tone.svg?react";
import Icon_Transition2 from "./generated-icons/transition-2.svg?react";
import Icon_Transition from "./generated-icons/transition.svg?react";
import Icon_TranslationShine from "./generated-icons/translation-shine.svg?react";
import Icon_Trash from "./generated-icons/trash.svg?react";
import Icon_Tree from "./generated-icons/tree.svg?react";
import Icon_TrimAi from "./generated-icons/trim-ai.svg?react";
import Icon_TrimBare from "./generated-icons/trim-bare.svg?react";
import Icon_Trim from "./generated-icons/trim.svg?react";
import Icon_Underline from "./generated-icons/underline.svg?react";
import Icon_UndoRedoDisplay from "./generated-icons/undo-redo-display.svg?react";
import Icon_Undo from "./generated-icons/undo.svg?react";
import Icon_Union from "./generated-icons/union.svg?react";
import Icon_Unlock from "./generated-icons/unlock.svg?react";
import Icon_UpArrowSmall from "./generated-icons/up-arrow-small.svg?react";
import Icon_Up from "./generated-icons/up.svg?react";
import Icon_Upload from "./generated-icons/upload.svg?react";
import Icon_VideoCameraSlash from "./generated-icons/video-camera-slash.svg?react";
import Icon_VideoCamera from "./generated-icons/video-camera.svg?react";
import Icon_VideoQuality from "./generated-icons/video-quality.svg?react";
import Icon_VolumeBox from "./generated-icons/volume-box.svg?react";
import Icon_Volume from "./generated-icons/volume.svg?react";
import Icon_Warning2 from "./generated-icons/warning-2.svg?react";
import Icon_Warning from "./generated-icons/warning.svg?react";
import Icon_Wave from "./generated-icons/wave.svg?react";
import Icon_WebError from "./generated-icons/web-error.svg?react";
import Icon_WebSearch from "./generated-icons/web-search.svg?react";
import Icon_Wipe from "./generated-icons/wipe.svg?react";
import Icon_Word2 from "./generated-icons/word-2.svg?react";
import Icon_WordEffects from "./generated-icons/word-effects.svg?react";
import Icon_Word from "./generated-icons/word.svg?react";
import Icon_WordsDesktop from "./generated-icons/words-desktop.svg?react";
import Icon_XIcon from "./generated-icons/x-icon.svg?react";
import Icon_XPadding from "./generated-icons/x-padding.svg?react";
import Icon_YPadding from "./generated-icons/y-padding.svg?react";
import Icon_Youtube from "./generated-icons/youtube.svg?react";
import Icon_ZoomAdd from "./generated-icons/zoom-add.svg?react";
import Icon_ZoomAi from "./generated-icons/zoom-ai.svg?react";
import Icon_ZoomIn from "./generated-icons/zoom-in.svg?react";
import Icon_ZoomLevel1x from "./generated-icons/zoom-level-1x.svg?react";
import Icon_ZoomLevel2x from "./generated-icons/zoom-level-2x.svg?react";
import Icon_ZoomLevel3 from "./generated-icons/zoom-level-3.svg?react";
import Icon_ZoomMultiple from "./generated-icons/zoom-multiple.svg?react";
import Icon_ZoomOut2 from "./generated-icons/zoom-out-2.svg?react";
import Icon_ZoomOut from "./generated-icons/zoom-out.svg?react";
import Icon_ZoomRemove from "./generated-icons/zoom-remove.svg?react";
import Icon_Zoom from "./generated-icons/zoom.svg?react";

export const generatedIconMap = {
  "edit-bare": Icon_EditBare,
  edit: Icon_Edit,
  group: Icon_Group,
  merge: Icon_Merge,
  copy: Icon_Copy,
  "trim-bare": Icon_TrimBare,
  trim: Icon_Trim,
  duplicate: Icon_Duplicate,
  position: Icon_Position,
  "delete-bare": Icon_DeleteBare,
  delete: Icon_Delete,
  "delete-all": Icon_DeleteAll,
  setting: Icon_Setting,
  none: Icon_None,
  like: Icon_Like,
  save: Icon_Save,
  saved: Icon_Saved,
  auto: Icon_Auto,
  "free-form": Icon_FreeForm,
  fit: Icon_Fit,
  fill: Icon_Fill,
  "select-all": Icon_SelectAll,
  "x-padding": Icon_XPadding,
  "y-padding": Icon_YPadding,
  scatter: Icon_Scatter,
  "animation-curve": Icon_AnimationCurve,
  add: Icon_Add,
  subtract: Icon_Subtract,
  "add-small": Icon_AddSmall,
  "subtract-small": Icon_SubtractSmall,
  create: Icon_Create,
  "clip-add": Icon_ClipAdd,
  cross: Icon_Cross,
  "cross-small": Icon_CrossSmall,
  options: Icon_Options,
  "checkmark-fill": Icon_CheckmarkFill,
  "checkmark-empty": Icon_CheckmarkEmpty,
  "hamburger-menu": Icon_HamburgerMenu,
  "copy-bare": Icon_CopyBare,
  "copy-ai": Icon_CopyAi,
  "content-auto": Icon_ContentAuto,
  "content-fit": Icon_ContentFit,
  "video-quality": Icon_VideoQuality,
  "ai-edit": Icon_AiEdit,
  overlay: Icon_Overlay,
  "to-overlay": Icon_ToOverlay,
  "to-clip": Icon_ToClip,
  check: Icon_Check,
  "position-captions": Icon_PositionCaptions,
  "position-freeform": Icon_PositionFreeform,
  "position-top": Icon_PositionTop,
  "position-bottom": Icon_PositionBottom,
  "position-left": Icon_PositionLeft,
  "position-right": Icon_PositionRight,
  "position-full": Icon_PositionFull,
  storage: Icon_Storage,
  "close-filled": Icon_CloseFilled,
  up: Icon_Up,
  down: Icon_Down,
  left: Icon_Left,
  right: Icon_Right,
  "left-up": Icon_LeftUp,
  "right-up": Icon_RightUp,
  "left-down": Icon_LeftDown,
  "right-down": Icon_RightDown,
  "swipe-right-round": Icon_SwipeRightRound,
  "swipe-left-round": Icon_SwipeLeftRound,
  "swipe-down-round": Icon_SwipeDownRound,
  "swipe-up-round": Icon_SwipeUpRound,
  "chevron-right": Icon_ChevronRight,
  "chevron-left": Icon_ChevronLeft,
  "chevron-down": Icon_ChevronDown,
  "chevron-up": Icon_ChevronUp,
  enlarge: Icon_Enlarge,
  minimize: Icon_Minimize,
  "enlarge-flipped": Icon_EnlargeFlipped,
  "minimize-flipped": Icon_MinimizeFlipped,
  expand: Icon_Expand,
  "minimize-2": Icon_Minimize2,
  "expand-flipped": Icon_ExpandFlipped,
  "minimize-flipped-2": Icon_MinimizeFlipped2,
  "undo-redo-display": Icon_UndoRedoDisplay,
  redo: Icon_Redo,
  undo: Icon_Undo,
  switch: Icon_Switch,
  "swipe-up": Icon_SwipeUp,
  "swipe-left": Icon_SwipeLeft,
  "zoom-out": Icon_ZoomOut,
  scale: Icon_Scale,
  "replace-bare": Icon_ReplaceBare,
  replace: Icon_Replace,
  rephrase: Icon_Rephrase,
  "rephrase-2": Icon_Rephrase2,
  export: Icon_Export,
  import: Icon_Import,
  upload: Icon_Upload,
  download: Icon_Download,
  "left-arrow-small": Icon_LeftArrowSmall,
  "right-arrow-small": Icon_RightArrowSmall,
  "link-out": Icon_LinkOut,
  shorten: Icon_Shorten,
  lengthen: Icon_Lengthen,
  "forward-10s": Icon_Forward10s,
  "backward-10s": Icon_Backward10s,
  "shortcut-display": Icon_ShortcutDisplay,
  "stretch-round": Icon_StretchRound,
  stretch: Icon_Stretch,
  "auto-fit": Icon_AutoFit,
  flip: Icon_Flip,
  "replace-bare-flip": Icon_ReplaceBareFlip,
  "reddit-to-video": Icon_RedditToVideo,
  "down-arrow-small": Icon_DownArrowSmall,
  "up-arrow-small": Icon_UpArrowSmall,
  outro: Icon_Outro,
  shuffle: Icon_Shuffle,
  intro: Icon_Intro,
  reorder: Icon_Reorder,
  warning: Icon_Warning,
  error: Icon_Error,
  success: Icon_Success,
  "loading-spinner": Icon_LoadingSpinner,
  "gradient-loading": Icon_GradientLoading,
  "purple-gradient-loading": Icon_PurpleGradientLoading,
  info: Icon_Info,
  "mirage-coin": Icon_MirageCoin,
  "progress-loading": Icon_ProgressLoading,
  "progress-loading-num": Icon_ProgressLoadingNum,
  "film-strip": Icon_FilmStrip,
  "film-strip-shine": Icon_FilmStripShine,
  "film-strip-multiple": Icon_FilmStripMultiple,
  "film-stripe-scene": Icon_FilmStripeScene,
  "film-strip-add": Icon_FilmStripAdd,
  "image-add": Icon_ImageAdd,
  "film-stripe-extend": Icon_FilmStripeExtend,
  "film-strip-check": Icon_FilmStripCheck,
  "film-stripe-cut": Icon_FilmStripeCut,
  "film-stripe-swatch": Icon_FilmStripeSwatch,
  "ai-ads": Icon_AiAds,
  "image-shine": Icon_ImageShine,
  image: Icon_Image,
  "image-multiple": Icon_ImageMultiple,
  background: Icon_Background,
  "background-shine": Icon_BackgroundShine,
  "flash-camera": Icon_FlashCamera,
  film: Icon_Film,
  leak: Icon_Leak,
  multimedia: Icon_Multimedia,
  flick: Icon_Flick,
  reel: Icon_Reel,
  "video-camera": Icon_VideoCamera,
  "video-camera-slash": Icon_VideoCameraSlash,
  flash: Icon_Flash,
  "flash-2": Icon_Flash2,
  "play-button": Icon_PlayButton,
  "fast-forward": Icon_FastForward,
  "fast-backward": Icon_FastBackward,
  "pause-button": Icon_PauseButton,
  "stop-button": Icon_StopButton,
  calendar: Icon_Calendar,
  "animate-video": Icon_AnimateVideo,
  "film-strip-replace": Icon_FilmStripReplace,
  "image-replace": Icon_ImageReplace,
  speaker: Icon_Speaker,
  volume: Icon_Volume,
  denoise: Icon_Denoise,
  sound: Icon_Sound,
  "sound-shine": Icon_SoundShine,
  music: Icon_Music,
  "music-shine": Icon_MusicShine,
  "audio-ducking": Icon_AudioDucking,
  "denoise-box": Icon_DenoiseBox,
  mic: Icon_Mic,
  "mic-add": Icon_MicAdd,
  "mic-shine": Icon_MicShine,
  "mic-edit": Icon_MicEdit,
  "mic-check": Icon_MicCheck,
  "mic-double": Icon_MicDouble,
  "audio-translated": Icon_AudioTranslated,
  "volume-box": Icon_VolumeBox,
  "sound-off": Icon_SoundOff,
  "sound-off-2": Icon_SoundOff2,
  "sound-off-3": Icon_SoundOff3,
  intensity: Icon_Intensity,
  "intensity-selected-low": Icon_IntensitySelectedLow,
  "intensity-selected-medium": Icon_IntensitySelectedMedium,
  "intensity-select-high": Icon_IntensitySelectHigh,
  revoice: Icon_Revoice,
  "revoice-box": Icon_RevoiceBox,
  "revoice-2": Icon_Revoice2,
  "extract-audio": Icon_ExtractAudio,
  "sound-add": Icon_SoundAdd,
  "replace-sound": Icon_ReplaceSound,
  "replace-sound-2": Icon_ReplaceSound2,
  "trim-ai": Icon_TrimAi,
  transition: Icon_Transition,
  filter: Icon_Filter,
  mirror: Icon_Mirror,
  "3d-background-add": Icon_3dBackgroundAdd,
  animation: Icon_Animation,
  "dotted-line-shine": Icon_DottedLineShine,
  color: Icon_Color,
  "color-2": Icon_Color2,
  "color-half-filled": Icon_ColorHalfFilled,
  style: Icon_Style,
  keyframes: Icon_Keyframes,
  zoom: Icon_Zoom,
  "zoom-multiple": Icon_ZoomMultiple,
  "zoom-add": Icon_ZoomAdd,
  "zoom-remove": Icon_ZoomRemove,
  "zoom-ai": Icon_ZoomAi,
  filtering: Icon_Filtering,
  stroke: Icon_Stroke,
  "corner-radius": Icon_CornerRadius,
  shadow: Icon_Shadow,
  "ai-color": Icon_AiColor,
  adjust: Icon_Adjust,
  sparkles: Icon_Sparkles,
  emphasize: Icon_Emphasize,
  stack: Icon_Stack,
  "duration-90": Icon_Duration90,
  "duration-60": Icon_Duration60,
  "duration-30": Icon_Duration30,
  "duration-45": Icon_Duration45,
  "duration-15": Icon_Duration15,
  duration: Icon_Duration,
  scenes: Icon_Scenes,
  scrolling: Icon_Scrolling,
  "super-fast": Icon_SuperFast,
  speed: Icon_Speed,
  slow: Icon_Slow,
  timing: Icon_Timing,
  "transition-2": Icon_Transition2,
  "create-template": Icon_CreateTemplate,
  "timing-filled": Icon_TimingFilled,
  "timing-2": Icon_Timing2,
  linear: Icon_Linear,
  "zoom-level-3": Icon_ZoomLevel3,
  "zoom-level-2x": Icon_ZoomLevel2x,
  "zoom-level-1x": Icon_ZoomLevel1x,
  timelines: Icon_Timelines,
  "duration-2": Icon_Duration2,
  "create-2": Icon_Create2,
  "edit-shot": Icon_EditShot,
  crop: Icon_Crop,
  "keyframe-convert": Icon_KeyframeConvert,
  "keyframe-delete": Icon_KeyframeDelete,
  "keyframe-add": Icon_KeyframeAdd,
  "keyframes-stack": Icon_KeyframesStack,
  instant: Icon_Instant,
  ease: Icon_Ease,
  "captions-ai": Icon_CaptionsAi,
  "captions-emphasis": Icon_CaptionsEmphasis,
  default: Icon_Default,
  "captions-edit": Icon_CaptionsEdit,
  "edit-filled": Icon_EditFilled,
  "position-2": Icon_Position2,
  "captions-translated": Icon_CaptionsTranslated,
  "captions-add": Icon_CaptionsAdd,
  "add-word": Icon_AddWord,
  "text-style": Icon_TextStyle,
  underline: Icon_Underline,
  font: Icon_Font,
  text: Icon_Text,
  "add-text": Icon_AddText,
  "text-shine": Icon_TextShine,
  "break-page": Icon_BreakPage,
  return: Icon_Return,
  space: Icon_Space,
  "break-desktop": Icon_BreakDesktop,
  "words-desktop": Icon_WordsDesktop,
  effects: Icon_Effects,
  "add-captions": Icon_AddCaptions,
  "captions-timing": Icon_CaptionsTiming,
  "edit-word": Icon_EditWord,
  "word-effects": Icon_WordEffects,
  script: Icon_Script,
  "search-captions": Icon_SearchCaptions,
  multidub: Icon_Multidub,
  "captions-top": Icon_CaptionsTop,
  "captions-bottom": Icon_CaptionsBottom,
  "captions-middle": Icon_CaptionsMiddle,
  "captions-bare": Icon_CaptionsBare,
  "left-align": Icon_LeftAlign,
  "right-align": Icon_RightAlign,
  "middle-align": Icon_MiddleAlign,
  page: Icon_Page,
  word: Icon_Word,
  line: Icon_Line,
  eye: Icon_Eye,
  "eye-off": Icon_EyeOff,
  "eye-contact": Icon_EyeContact,
  "lip-auto": Icon_LipAuto,
  "emoji-shine": Icon_EmojiShine,
  emoji: Icon_Emoji,
  "translation-shine": Icon_TranslationShine,
  conversation: Icon_Conversation,
  profile: Icon_Profile,
  "3d-background": Icon_3dBackground,
  "captions-person": Icon_CaptionsPerson,
  person: Icon_Person,
  "person-add": Icon_PersonAdd,
  "person-ai": Icon_PersonAi,
  "person-ai-mirage": Icon_PersonAiMirage,
  "chat-shine": Icon_ChatShine,
  censor: Icon_Censor,
  hide: Icon_Hide,
  language: Icon_Language,
  clothes: Icon_Clothes,
  "hide-punctuation": Icon_HidePunctuation,
  chat: Icon_Chat,
  "help-filled": Icon_HelpFilled,
  help: Icon_Help,
  "face-tracking": Icon_FaceTracking,
  "character-add": Icon_CharacterAdd,
  "teams-box": Icon_TeamsBox,
  teams: Icon_Teams,
  "cutout-bg-removal": Icon_CutoutBgRemoval,
  show: Icon_Show,
  echo: Icon_Echo,
  tone: Icon_Tone,
  "ai-twin": Icon_AiTwin,
  comments: Icon_Comments,
  "cutout-bg-v2": Icon_CutoutBgV2,
  lock: Icon_Lock,
  unlock: Icon_Unlock,
  briefcase: Icon_Briefcase,
  shield: Icon_Shield,
  title: Icon_Title,
  tip: Icon_Tip,
  bell: Icon_Bell,
  fire: Icon_Fire,
  light: Icon_Light,
  metadata: Icon_Metadata,
  gif: Icon_Gif,
  book: Icon_Book,
  "book-shine": Icon_BookShine,
  split: Icon_Split,
  teleprompter: Icon_Teleprompter,
  home: Icon_Home,
  chain: Icon_Chain,
  "crumpled-paper": Icon_CrumpledPaper,
  "retro-paper": Icon_RetroPaper,
  "folder-add": Icon_FolderAdd,
  api: Icon_Api,
  phone: Icon_Phone,
  laptop: Icon_Laptop,
  "script-2": Icon_Script2,
  pag: Icon_Pag,
  baby: Icon_Baby,
  pirate: Icon_Pirate,
  "milk-bottle": Icon_MilkBottle,
  texas: Icon_Texas,
  "gen-z": Icon_GenZ,
  credits: Icon_Credits,
  "credits-shine": Icon_CreditsShine,
  "folder-download": Icon_FolderDownload,
  "phone-number": Icon_PhoneNumber,
  email: Icon_Email,
  "caption-coin": Icon_CaptionCoin,
  "credit-card": Icon_CreditCard,
  online: Icon_Online,
  cap: Icon_Cap,
  glasses: Icon_Glasses,
  offline: Icon_Offline,
  cube: Icon_Cube,
  block: Icon_Block,
  circle: Icon_Circle,
  bar: Icon_Bar,
  square: Icon_Square,
  diamond: Icon_Diamond,
  "title-2": Icon_Title2,
  pixel: Icon_Pixel,
  glitch: Icon_Glitch,
  fan: Icon_Fan,
  "captions-flower": Icon_CaptionsFlower,
  "captions-flower-pedal": Icon_CaptionsFlowerPedal,
  wave: Icon_Wave,
  paint: Icon_Paint,
  surprise: Icon_Surprise,
  money: Icon_Money,
  flare: Icon_Flare,
  glow: Icon_Glow,
  bokeh: Icon_Bokeh,
  above: Icon_Above,
  below: Icon_Below,
  "page-2": Icon_Page2,
  "line-2": Icon_Line2,
  "word-2": Icon_Word2,
  "size-lg": Icon_SizeLg,
  "size-me": Icon_SizeMe,
  "size-sm": Icon_SizeSm,
  fade: Icon_Fade,
  pop: Icon_Pop,
  instagram: Icon_Instagram,
  "instagram-story": Icon_InstagramStory,
  tiktok: Icon_Tiktok,
  snapchat: Icon_Snapchat,
  shorts: Icon_Shorts,
  shopify: Icon_Shopify,
  linkedin: Icon_Linkedin,
  reddit: Icon_Reddit,
  youtube: Icon_Youtube,
  mirage: Icon_Mirage,
  "scale-1x1": Icon_Scale1x1,
  "scale-16x9": Icon_Scale16x9,
  "scale-9x16": Icon_Scale9x16,
  "scale-4x5": Icon_Scale4x5,
  "aspect-ratio-16x9": Icon_AspectRatio16x9,
  "aspect-ratio-9x16": Icon_AspectRatio9x16,
  "aspect-ratio-1x1": Icon_AspectRatio1x1,
  "aspect-ratio-4x5": Icon_AspectRatio4x5,
  "aspect-ratio": Icon_AspectRatio,
  "aspect-ratio-2": Icon_AspectRatio2,
  "split-screen-vertical": Icon_SplitScreenVertical,
  "split-screen-horizontal": Icon_SplitScreenHorizontal,
  "error-2": Icon_Error2,
  "close-bubble": Icon_CloseBubble,
  caution: Icon_Caution,
  "warning-2": Icon_Warning2,
  trash: Icon_Trash,
  "success-2": Icon_Success2,
  "outline-checkmark": Icon_OutlineCheckmark,
  "gradient-loading-number": Icon_GradientLoadingNumber,
  "clap-board": Icon_ClapBoard,
  "speaker-2": Icon_Speaker2,
  folder: Icon_Folder,
  "folder-open": Icon_FolderOpen,
  "project-list": Icon_ProjectList,
  "random-dice": Icon_RandomDice,
  random: Icon_Random,
  "film-strip-extend": Icon_FilmStripExtend,
  "film-strip-cut": Icon_FilmStripCut,
  "fire-2": Icon_Fire2,
  "sound-waves": Icon_SoundWaves,
  dark: Icon_Dark,
  "captions-flower-clover": Icon_CaptionsFlowerClover,
  "x-icon": Icon_XIcon,
  google: Icon_Google,
  microsoft: Icon_Microsoft,
  apple: Icon_Apple,
  "checkmark-number": Icon_CheckmarkNumber,
  planner: Icon_Planner,
  "new-chat": Icon_NewChat,
  grab: Icon_Grab,
  switcher: Icon_Switcher,
  "minimize-3": Icon_Minimize3,
  "film-strip-download": Icon_FilmStripDownload,
  "sound-2": Icon_Sound2,
  srt: Icon_Srt,
  spacing: Icon_Spacing,
  "line-height": Icon_LineHeight,
  "web-error": Icon_WebError,
  "web-search": Icon_WebSearch,
  brain: Icon_Brain,
  "thumb-up": Icon_ThumbUp,
  "thumb-up-filled": Icon_ThumbUpFilled,
  "thumb-down": Icon_ThumbDown,
  "thumb-down-filled": Icon_ThumbDownFilled,
  attachment: Icon_Attachment,
  tree: Icon_Tree,
  "mirage-icon": Icon_MirageIcon,
  hd: Icon_Hd,
  "flip-2": Icon_Flip2,
  "zoom-in": Icon_ZoomIn,
  mask: Icon_Mask,
  magnifying: Icon_Magnifying,
  shake: Icon_Shake,
  fold: Icon_Fold,
  shutter: Icon_Shutter,
  "split-2": Icon_Split2,
  "stretch-2": Icon_Stretch2,
  wipe: Icon_Wipe,
  blend: Icon_Blend,
  rotate: Icon_Rotate,
  "circle-2": Icon_Circle2,
  blur: Icon_Blur,
  "zoom-out-2": Icon_ZoomOut2,
  negative: Icon_Negative,
  "cloud-download": Icon_CloudDownload,
  "handle-asym": Icon_HandleAsym,
  "handle-sym": Icon_HandleSym,
  "handle-none": Icon_HandleNone,
  "left-align-2": Icon_LeftAlign2,
  "middle-align-2": Icon_MiddleAlign2,
  "right-align-2": Icon_RightAlign2,
  "justified-align": Icon_JustifiedAlign,
  "bullet-list": Icon_BulletList,
  "intensity-high-filled": Icon_IntensityHighFilled,
  "intensity-medium-filled": Icon_IntensityMediumFilled,
  "intensity-low-filled": Icon_IntensityLowFilled,
  ruler: Icon_Ruler,
  "rotate-90-degrees": Icon_Rotate90Degrees,
  "flip-horizontally": Icon_FlipHorizontally,
  "flip-vertically": Icon_FlipVertically,
  union: Icon_Union,
  "subtract-2": Icon_Subtract2,
  intersect: Icon_Intersect,
  exclude: Icon_Exclude,
  "stroke-all": Icon_StrokeAll,
  "stroke-top": Icon_StrokeTop,
  "stroke-bottom": Icon_StrokeBottom,
  "stroke-left": Icon_StrokeLeft,
  "stroke-right": Icon_StrokeRight,
  "shape-left-align": Icon_ShapeLeftAlign,
  "shape-v-center-align": Icon_ShapeVCenterAlign,
  "shape-right-align": Icon_ShapeRightAlign,
  "shape-top-align": Icon_ShapeTopAlign,
  "shape-h-center-align": Icon_ShapeHCenterAlign,
  "shape-bottom-align": Icon_ShapeBottomAlign,
  "chain-broken": Icon_ChainBroken,
  rotation: Icon_Rotation,
  tag: Icon_Tag,
};
